import { render, staticRenderFns } from "./TopPurchasesChart.vue?vue&type=template&id=676633d3"
import script from "./TopPurchasesChart.vue?vue&type=script&lang=js"
export * from "./TopPurchasesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports